<template>
	<li :class="deletedClass">
		<div class="user-image">
			<img
				v-if="user.photoURL"
				v-lazy=" {src: user.photoURL, error: noImage }"
				:title="`${user.firstName} ${user.lastName}`"
				@click="goToUser(user)"
				alt="Profile picture"
			/>
			<div v-else class="user-image">
				<no-user-image
					:firstName="user.firstName"
					:lastName="user.lastName"
					:fontSize="15"
					@click.prevent="goToUser(user)"
				></no-user-image>
			</div>
		</div>
		<div class="user-details" @click="goToUser(user)">
			<span>{{usersName(user)}}</span>
			<span>@{{user.username}}</span>
		</div>
		<div v-if="!from" class="follow-button">
			<span v-if="user.deleted" class="stackng-note">User deleted</span>
			<follow-button v-else :user="user" :from="componentName"></follow-button>
		</div>
		<div v-else-if="from === 'groups-search'" class="add-button">
			<span v-if="user.deleted" class="stackng-note">User deleted</span>
			<groups-add-button v-else @userAdded="addToGroup(user)" @userRemoved="removeFromGroup(user)"></groups-add-button>
		</div>
		<div v-else-if="from === 'groups-options'" class="groups-options-roles">
			<span v-if="isAdmin(user)">
				<ion-icon name="ios-lock"></ion-icon>admin
			</span>
			<div v-if="user.deleted" class="deleted-note">
				<span class="stackng-note">User deleted</span>
			</div>
		</div>
	</li>
</template>

<script>
import FollowButton from "./UserFollowButton.vue";
import GroupsAddButton from "../../groups/GroupsAddButton.vue";
import NoUserImage from "../../errors/NoUserImage.vue";

export default {
	data() {
		return {
			componentName: "usersList",
			noImage:
				"https://icons-for-free.com/iconfiles/png/512/login+person+profile+user+users+icon-1320166527284195604.png"
		};
	},
	props: {
		user: {
			type: Object
		},
		from: {
			type: String
		},
		admin: {
			type: String
		}
	},
	components: {
		FollowButton,
		GroupsAddButton,
		NoUserImage
	},
	computed: {
		deletedClass() {
			if (this.user.deleted) {
				return "user-deleted";
			}
		}
	},
	methods: {
		//FOR GENERAL USE
		usersName(item) {
			return item.name ? item.name : `${item.firstName} ${item.lastName}`;
		},
		goToUser(result) {
			if (!this.from) {
				this.closeModal();
				this.$router.push({ path: `/s/${result.username}` });
			}
		},
		closeModal() {
			const html = document.querySelector("html");
			const modalContainer = this.$parent.$el;
			const app = document.querySelector("#app");
			app.classList.remove("blur-app");
			modalContainer.removeEventListener("click", this.closeModal);
			html.style.overflowY = "scroll";

			let payload = {
				show: false,
				users: null,
				story: null
			};
			this.$store.commit("updateStoryModal", payload);
		},

		//FOR GROUPS
		addToGroup(user) {
			this.$emit("userAdded", user);
		},
		removeFromGroup(user) {
			this.$emit("userRemoved", user);
		},
		isAdmin(item) {
			let memberID = item.userID ? item.userID : item.objectID;
			return this.admin === memberID;
		}
	}
};
</script>

<style scoped>
li {
	display: grid;
	width: 100%;
	grid-template-columns: 1fr 2fr 2fr;
	align-items: center;
	margin-bottom: 10px;
}

.user-image {
	text-align: center;
	cursor: pointer;
	height: 50px;
	width: 50px;
	border-radius: 50%;
}

img {
	height: 50px;
	width: 50px;
	object-fit: cover;
	border-radius: 50%;
	/* border: 2px solid #51c715; */
	padding: 2px;
}

.user-details {
	vertical-align: middle;
	font-size: 12px;
	padding-left: 10px;
	cursor: pointer;
}

.user-details span {
	vertical-align: middle;
	display: block;
}

.user-details span:first-of-type {
	font-weight: bold;
	color: #b7b7b7;
}

.user-details span:last-of-type {
	color: #51c715;
}

.follow-button,
.add-button {
	text-align: right;
}

.user-deleted {
	pointer-events: none;
}

.user-deleted .user-details,
.user-deleted .user-image {
	opacity: 0.3;
}

.deleted-note .stackng-note {
	font-size: 10px;
}

@media only screen and (max-width: 1300px) {
	img,
	.user-image {
		height: 40px;
		width: 40px;
	}
}

@media only screen and (max-width: 400px) {
	li {
		align-items: normal;
	}
}

/* FOR GROUPS */
.groups-options-roles {
	display: block;
	text-align: center;
	color: #b7b7b7;
	font-size: 10px;
	margin-top: 15px;
	margin-bottom: 15px;
}

ion-icon[name="ios-lock"] {
	vertical-align: sub;
}
</style>



// WEBPACK FOOTER //
// src/components/users/userView/UsersListItem.vue